import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { AudioProvider } from './context/AudioContext';

ReactDOM.render(
  <Router>
    <AudioProvider>
      <App />
    </AudioProvider>
  </Router>,
  document.getElementById('root')
);